<template>
  <div class="pipeline_layout--menu">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "PipelineLayoutMenu",
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.pipeline_layout--menu {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 300px;
  padding-right: $defaultGap;
  overflow-y: auto;
  overflow-x: hidden;

  @media screen and (min-width: 1400px) {
    flex-basis: 340px;
  }

  @media screen and (min-width: 1600px) {
    flex-basis: 400px;
  }
}
</style>
